var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.2 0H4.8A4.8 4.8 0 000 4.8v35.4A4.8 4.8 0 004.8 45h13.8V29.7h-6.3v-7.2h6.3V17c0-6.2 3.7-9.7 9.4-9.7a38.3 38.3 0 015.6.5V14h-3.1c-3.1 0-4.1 2-4.1 4v4.6h6.9l-1.1 7.2h-5.8V45h13.8a4.8 4.8 0 004.8-4.8V4.8A4.8 4.8 0 0040.2 0z","fill":"#fff"}));
}

Facebook.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = Facebook;

Facebook.default = Facebook;
